import { COMPONENT_TYPE, SEND_FROM_DATA } from '../constants';
import { ModalManager } from '../managers/ModalManager';
import { insertHtmlWithScripts } from './domUtils';
import { SendData } from './SendData';

export async function ajax(options) {
  let url = options.url;
  let method = options.type || 'GET';
  let headers = options.headers || {};
  let body = null;

  if (options.cache === false) {
    url += (url.includes('?') ? '&' : '?') + '_=' + new Date().getTime();
  }

  if (options.data) {
    if (method === 'GET' || method === 'HEAD') {
      url += (url.includes('?') ? '&' : '?') + serialize(options.data);
    } else {
      if (options.contentType === 'application/json') {
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify(options.data);
      } else if (options.contentType === 'application/x-www-form-urlencoded; charset=UTF-8') {
        headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        body = serialize(options.data);
      } else if (options.contentType === false) {
        body = options.data;
      } else {
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify(options.data);
      }
    }
  }

  if (options.dataType === 'json') {
    headers['Accept'] = 'application/json';
  }

  if (method !== 'GET') {
    headers['X-Request-Method'] = method || 'POST'; // По умолчанию POST
    method = 'POST';
  }

  // Перед отправкой запроса
  if (options.beforeSend) {
    options.beforeSend();
  }

  const controller = new AbortController();
  const signal = controller.signal;
  let timeoutId;

  fetch(url, {
    method: method,
    headers: headers,
    body: body,
    signal: options.signal
  })
    .then(async function (response) {
      const contentType = response.headers.get('content-type');
      let responseData;

      if (options.dataType === 'script') {
        responseData = await response.text();
        const scriptElement = document.createElement('script');
        scriptElement.text = responseData;
        document.head.appendChild(scriptElement).parentNode.removeChild(scriptElement);
        options.success && options.success(responseData, response.status, response);
      } else if (contentType && contentType.startsWith('image/')) {
        // Для изображений возвращаем Blob
        responseData = await response.blob();
      } else if (contentType && contentType.includes('application/json') && response.ok) {
        responseData = await response.json();
      } else {
        responseData = await response.text();
        if (contentType && contentType.includes('application/json') && !response.ok) {
          try {
            responseData = JSON.parse(responseData);
          } catch (e) {
            // Если не удалось распарсить JSON, оставляем как есть
          }
        }
      }

      if (response.ok) {
        // Сохраняем данные в sessionStorage, если указано
        options.success && options.success(responseData, response.status, response);
      } else {
        response.responseText = responseData;
        options.error && options.error(response, response.status, response.statusText, responseData);
      }
    })
    .catch(async (response) => console.error(response));
}

export function sendData(data, url) {
  console.warn('Вы используете устаревшую функцию');
  return new SendData({
    data,
    url
  });
}

export async function sendCardData({ elem, url, data = {}, redirect = null, disableValidate = false, messageAuto = false, loading = null, type = 'POST' }) {
  const form = elem.closestInParent('form');
  const fieldset = elem.querySelector('fieldset');

  if (!disableValidate && !(await window.validateForm({ elem: form, disableValidate, customValidate: form?.customValidate }))) {
    return Promise.reject(false);
  }

  if (fieldset) {
    Object.assign(data, fieldset.data);
  }

  return new SendData({
    redirect,
    elem,
    data,
    url,
    messageAuto,
    type,
    headers: { [COMPONENT_TYPE]: SEND_FROM_DATA },
    loading,
  });
}

export function sendModalData({ confirmText = '', elem, url, data = {}, disableValidate = false, messageAuto = false, loading = null, type = 'POST' }) {
  /**
   * @type {ModalManager}
   */
  const modal = elem.closest('.modal').modalManager;
  if (disableValidate) modal.disableValidate = disableValidate;
  return new Promise((resolve, reject) => {
    modal.sendDataPromice = resolve;
  }).then((modalResponseData) => {
    if (confirmText && !confirm(confirmText)) return;
    new SendData({
      data: Object.assign(modalResponseData, data),
      url: url,
      messageAuto,
      loading,
      type,
    }).then((response) => modal.resolve(response));
  });
}

export function render(path, data, method, context) {
  new SendData({ data, url: '/do/renderElement?path=' + path }).then((response) => {
    const element = document.createElement('div');
    insertHtmlWithScripts({ html: response.answer, parent: element });
    method.call(context, ...element.children); // Вызов метода с правильным контекстом
  });
}

export function sendForm(event, formElement, actionPath) {
  event.preventDefault();
  $fieldset = formElement.querySelector('fieldset');
  if (!$fieldset) return;
  const formData = getDataAll($fieldset); // Создаем новый объект FormData из переданной формы
  sendData(formData, actionPath).then((response) => {
    // Проверка на наличие пути в ответе сервера
    const answer = response.answer;
    if (answer.path) {
      window.location.href = answer.path; // Переход по указанному пути
    } else {
      window.location.reload(); // Перезагрузка страницы, если путь не был получен
    }
  });
}


/**
 * Установить значение в sessionStorage
 * @param {string} key - Ключ для хранения данных
 * @param {any} value - Значение для хранения
 */
export function getHead(key) {
  const head = document.querySelector('head');
  const meta = head.querySelector(`meta[name="${key}"]`);
  return meta ? meta.getAttribute('content') : null;
}

/**
 * Установить значение в sessionStorage
 * @param {string} key - Ключ для хранения данных
 * @param {any} value - Значение для хранения
 */
export function setSessionStorage(key, value) {
  try {
    let data;
    if (typeof value === 'string') {
      // Если это строка, сохраняем как есть
      data = JSON.stringify({ type: 'string', value });
    } else if (typeof value === 'number') {
      // Если это число
      data = JSON.stringify({ type: 'number', value });
    } else if (typeof value === 'boolean') {
      // Если это булево значение
      data = JSON.stringify({ type: 'boolean', value });
    } else if (value === null) {
      // Если это null
      data = JSON.stringify({ type: 'null', value: null });
    } else if (typeof value === 'object') {
      // Если это объект или массив
      data = JSON.stringify({ type: 'object', value });
    } else {
      throw new Error('Unsupported data type');
    }
    sessionStorage.setItem(key, data);
  } catch (error) {
    console.error('Ошибка при сохранении в sessionStorage:', error);
  }
}

/**
 * Получить значение из sessionStorage
 * @param {string} key - Ключ для получения данных
 * @returns {any} - Значение из sessionStorage или null, если ключ не найден
 */
export function getSessionStorage(key) {
  try {
    const data = sessionStorage.getItem(key);
    if (!data) return null;

    const parsed = JSON.parse(data);
    switch (parsed.type) {
      case 'string':
        return parsed.value;
      case 'number':
        return parsed.value;
      case 'boolean':
        return parsed.value;
      case 'null':
        return null;
      case 'object':
        return parsed.value;
      default:
        throw new Error('Unsupported data type');
    }
  } catch (error) {
    console.error('Ошибка при чтении из sessionStorage:', error);
    return null;
  }
}

/**
 * Удалить значение из sessionStorage
 * @param {string} key - Ключ для удаления данных
 */
export function removeSessionStorage(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.error('Ошибка при удалении из sessionStorage:', error);
  }
}